// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Neo5","boxTitle":"Qualiphy_boxTitle__17ppb","box":"Qualiphy_box__1Qx-n","toggleWrap":"Qualiphy_toggleWrap__1DcHr"};